import StepWizard, { type StepDefinition } from "./StepWizard";

export interface CardAnswers {
  공무원: string;
  카드나이: string;
  부정수급: string;
}

interface CardFormProps {
  answers: CardAnswers;
  onChange: (answers: CardAnswers) => void;
  onSubmit: () => void;
}

const cardSteps: StepDefinition[] = [
  {
    key: "공무원",
    type: "radio",
    legend: "1. 공무원 신분인가요",
    description: "국민내일배움카드 운영규정 §4② 발급 제외 대상 중 하나입니다.",
    options: [
      { value: "아니오", label: "아닙니다" },
      { value: "예", label: "공무원입니다" },
    ],
  },
  {
    key: "카드나이",
    type: "input",
    legend: "2. 나이",
    description: "발급 제외 대상에 연령 상한(만 75세 이상)이 있습니다.",
    inputLabel: "만 나이",
    inputMin: 10,
    inputMax: 110,
    inputPlaceholder: "예: 27",
  },
  {
    key: "부정수급",
    type: "radio",
    legend: "3. 국비 훈련 부정수급으로 제재를 받은 적이 있나요",
    description: "부정수급 제재기간 중에는 카드 발급이 제한됩니다(최대 5배 반환 + 발급 제한).",
    options: [
      { value: "아니오", label: "없습니다" },
      { value: "예", label: "제재 기간 중이거나 최근에 있었습니다" },
    ],
  },
];

export default function CardForm({ answers, onChange, onSubmit }: CardFormProps) {
  const banner = (
    <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6 text-sm text-gray-700 leading-relaxed dark:border-amber-800 dark:bg-amber-900/20 dark:text-amber-100">
      카드 발급 게이트만 원문 대조가 끝나 있습니다. KDT·국기·산대특의 직종·정원 등
      <b> 과정별 세부 조건은 이 화면이 만들어내지 않습니다</b> — 공고문·제도안내·상담으로 확인해 주세요.
    </div>
  );

  const firstUnanswered = cardSteps.findIndex((s) => !answers[s.key as keyof CardAnswers]);
  const initialIndex = firstUnanswered === -1 ? cardSteps.length - 1 : firstUnanswered;

  return (
    <StepWizard
      steps={cardSteps}
      answers={answers as unknown as Record<string, string | boolean>}
      onFieldChange={(key, value) =>
        onChange({ ...answers, [key]: value } as CardAnswers)
      }
      onComplete={onSubmit}
      initialIndex={initialIndex}
      banner={banner}
    />
  );
}